import * as React from 'react';
export default function Banner({ text, linktext, href }) {
    return (React.createElement("div", { className: "mw7 center tc ph3 ph5-ns pa4 bg-banner" },
        React.createElement("span", null, text),
        React.createElement("span", null,
            React.createElement("a", { href: href, className: "no-underline" }, linktext))));
}
//# sourceMappingURL=Banner.js.map